<template>
  <header id="site-header">
    <figure class="logo">
      <a href="/">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 695.85 101.23"><polygon points="279.14 23.86 217.46 23.86 212.26 39.71 250.72 39.71 242.86 63.44 204.87 63.44 199.66 79.29 255.22 79.29 270.64 32.37 279.14 23.86"/><path d="M278.67,53.56c11.14.55,40.72,4.67,52.85,7.41l4.91-14.95c-18.26-3.91-27.02-5.21-52.71-7.82l-5.05,15.37Z"/><path d="M270.39,73.32c16.58,1.71,32.71,3.98,56.21,7.82l5.14-15.64c-16.11-3.36-37.75-6.58-56.03-8.37l-5.32,16.19Z"/><path d="M284.94,34.5c14.87.89,33.21,3.29,52.98,7l4.98-15.16c-15.15-2.95-33.75-5.21-53.12-6.58l-4.85,14.75Z"/><polygon points="344.66 58.3 395.09 58.3 410.59 42.8 349.76 42.8 344.66 58.3"/><path d="M479.36,31.75l3.4-10.36h-16.8l-3.4,10.36h-13.99l3.4-10.36h-16.05l-3.4,10.36h-8.23l-4.82,14.68h8.23l-4.44,13.51h16.05l4.44-13.51h13.99l-2.48,7.55c-2.75,8.16-7.27,10.84-18.7,10.98h-4.63l-15.37,15.37h17.7c18.57.27,31.97-8.99,37.56-25.79l2.66-8.09h7.96l4.83-14.68h-7.89Z"/><path d="M555.94,29.01l8.49-8.51h-21.91c-2.78,7-3.8,8.03-10.88,10.56l-40.92,14.95-5.25,15.98,26.34-9.4-9.49,28.88h16.74l11.77-35.81c16.12-6.12,21.06-8.65,25.11-16.67Z"/><path d="M621.58,29.69l8.51-8.5h-55.65c-5.69,15.85-8.12,19.07-15.36,20.65l-5.34,16.26c8.34-1.37,12.22-2.74,17.96-6.45,5.13-3.5,7.92-7,12.09-15.3h18.59l-5.28,16.05c-4.02,10.77-8.69,13.51-23.14,13.44h-8.09l-15.02,15.02h23.46c10.97-.21,18.78-2.26,24.8-6.38,7.41-5.01,11.15-10.56,15.08-22.29l7.4-22.5Z"/><path d="M674.73,36l-7.12,21.68c-1.31,4.18-3.86,6.31-7.31,6.17l14.07-42.8h-16.46l-19.28,58.65h16.12c13.92-.21,24.08-7.75,27.93-20.92l4.69-14.26,8.49-8.51h-21.12Z"/><path d="M653.92,21.05h-16.32l-11.7,35.6c-2.14,6.31-3.58,7.75-8.69,8.51l-5.34,16.26c9.39-.82,15.62-3.29,20.93-8.16,4.71-4.53,6.75-8.44,10.72-20.51l10.42-31.69Z"/><path d="M55.68,26.62c1.13-2.35,2.24-4.7,3.33-7.05-9.73,1.68-9.3-8.83.96-11.43,6.31-.58,20.31,0,26.73-.18-17.43,19.93-32.41,40.89-46.27,61.68,9.68-10.32,30.17-33.29,37.3-41.06l22.89,33.56,38.76-42.86-52.29.05c5.1-6.19,10.76-12.21,15.78-18.42-.07-.01-27.07,0-27.17-.01-7.09.11-15.17-1.18-22.78,3.89-14.2,8.48-11.9,23.69,2.77,21.83ZM123.16,26.65l-20.04,22.61-15.15-22.55,35.19-.05Z"/><path d="M75.48,38.27c-2.18,2.52-4.35,5.07-6.38,7.64,20.39,15.86-15.83,52.84-45.23,46.85-31.26-7.09-5.35-50.91,30.52-52.82,1.68-2.18,3.89-5.21,5.26-7.42-21.06-.49-47.27,15.89-56.02,34.01-14.01,26.13,15,44.56,47.09,28.95,29.78-12.88,44.18-45.69,24.77-57.22Z"/><path d="M115.35,7c7.51,6.15,19.3,8.67,31.19,9.73,9.15-6.91,19.86-12.34,30.62-15.32,1.89-.52,3.71-.84,5.59-1.29-21.17-1.47-46.82,9.82-67.4,6.87Z"/><polygon points="119.59 48.81 104.57 65.75 131.19 65.7 119.59 48.81"/><path d="M163.61,34.52c-9.78-3.87-23.56-1.6-36.26,4.42l-4.35,4.81,3.16,4.6c15.26-8.1,32.74-8.21,37.76,3.35,8.65,23.42-41.76,53.17-54.57,31.35,12.51,15.28,50.7-4.1,49.5-25.11-1.6-11.7-16.77-12.95-30.32-6.12l13.41,19.54-46.85.08-1.26,3.2c-4.77,16.56,7.98,26.48,28.01,26.59,17.43.1,38.48-13.73,48.4-28.61,11.35-16.1,8.39-32.99-6.64-38.11Z"/></svg>
      </a>
    </figure>
    <nav class="gnavi" role="navigation" itemscope="itemscope" itemtype="http://scheme.org/SiteNavigationElement">
      <ul>
        <li itemprop="name"><a itemprop="url" href="/">トップページ</a></li>
        <li itemprop="name"><a itemprop="url" href="/about/">お知らせ</a></li>
        <li itemprop="name"><a itemprop="url" href="/about/">取り扱いブランド</a></li>
        <li itemprop="name"><a itemprop="url" href="/about/">工賃表</a></li>
      </ul>
    </nav>
    <a href="" class="btn">お問い合わせ</a>
  </header>
</template>

<style lang="scss" scoped>
header{
  width: 100%;
  top: 0;
  left: 50%;
  position: fixed;
  padding: 1rem module.side();
  display: grid;
  grid-template-columns: auto auto;
  z-index: 1000;
  transform: translateX(-50%);
  transition: width 800ms module.$ease;
  &:before{
    content: '';
    width: 100%;
    height: 0;
    position: absolute;
    top: 0;
    left: 0;
    background: module.$white;
    z-index: -1;
    transition: height 800ms module.$ease;
    border-radius: 0 0 1rem 1rem;
  }
  &.active{
    width: 95%;
    &:before{
      height: 100%;
      box-shadow: 0 0 3.2rem rgba(module.$normal,.16);
    }
  }
  > *{
    align-self: center;
  }
  .logo{
    width: 15.6rem;
    justify-self: flex-start;
    a{
      display: block;
      svg{
        display: block;
        fill: module.$base;
      }
    }
  }
  nav{
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ul{
      @include module.flex();
      justify-content: center;
      align-items: center;
      li{
        margin: 0 0 0 2rem;
        padding: 0 0 0 2rem;
        position: relative;
        &:before{
          content: '';
          width: 1px;
          height: 100%;
          background: module.$base;
          position: absolute;
          top: 0;
          left: 0;
          transform: rotate(25deg);
          opacity: .24;
        }
        a{
          font-size: .92rem;
          line-height: 1;
          color: module.$base;
          font-weight: 700;
          display: block;
          &:hover{
            text-decoration: underline;
          }
        }
        &:first-child{
          margin: 0;
          padding: 0;
          &::before{
            display: none;
          }
        }
      }
    }
  }
  .btn{
    justify-self: flex-end;
    @include module.btn();
  }
}
</style>

<script>
export default {
}
</script>
